import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IconsModule } from "../icons/icons.module";
import { LaunchCountdownDigitComponent } from "./launch-countdown-digit.component";

@NgModule({
  imports: [
    // Common
    CommonModule,
    IconsModule
  ],
  declarations: [LaunchCountdownDigitComponent],
  exports: [LaunchCountdownDigitComponent],
})
export class LaunchCountdownDigitComponentModule { }
